import { render, staticRenderFns } from "./fundRecord.vue?vue&type=template&id=01c430de&scoped=true"
import script from "./fundRecord.vue?vue&type=script&lang=js"
export * from "./fundRecord.vue?vue&type=script&lang=js"
import style0 from "./fundRecord.vue?vue&type=style&index=0&id=01c430de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c430de",
  null
  
)

export default component.exports